const mailEvent = {
  SEND_MAIL: 'SEND_MAIL'
};
  
export default mailEvent;